module.exports = __webpack_public_path__ + "static/media/openToast.50ad64b8.mp3";